import React from "react";
import { useTranslation } from "react-i18next";
import image1 from "../../../assets/images/Accreditation-logo.jpg";
import image2 from "../../../assets/images/footerImg.jpg";
import image3 from "../../../assets/images/footerImg1.jpg";

const logos = [image1, image3, image2];

// Only confirmed items are shown. ACTD (index 0) is confirmed; the ERMA and AAPM
// trainer certifications (indexes 1–2) stay hidden until confirmed.
const CONFIRMED = [0];

const Accreditation = () => {
  const { t } = useTranslation();
  const accreditations = t("home.accreditation.items", { returnObjects: true })
    .map((item, i) => ({ ...item, logo: logos[i] }))
    .filter((_, i) => CONFIRMED.includes(i));
  const last = accreditations.length - 1;

  return (
    <section className="py-20 bg-[#f4f6f9] border-t border-b border-gray-100">
      <div className="max-w-[1560px] mx-auto px-6">
        <div className={`grid grid-cols-1 ${accreditations.length === 1 ? "max-w-2xl mx-auto" : "md:grid-cols-3"}`}>
          {accreditations.map((item, index) => (
            <div 
              key={index} 
              className={`flex flex-col items-start text-left p-8 lg:p-12 xl:p-16 ${
                index !== last ? 'md:border-r border-gray-200' : ''
              } ${index !== last ? 'border-b md:border-b-0 border-gray-200' : ''}`}
            >
              <div className="w-16 h-16 shrink-0 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center p-2 mb-8">
                <img 
                  src={item.logo} 
                  alt={item.title} 
                  className="w-full h-full object-contain" 
                />
              </div>
              <h3 className="text-[#0b0f19] font-bold text-xl mb-4">
                {item.title}
              </h3>
              <p className="text-gray-500 font-medium leading-relaxed text-[15px]">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accreditation;